import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {
  postBillingGrrByItinerary,
  postBillingGrrByItineraryV2,
} from '../../../../../actions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { generateGrrBillingByItineraryEndpoint } from '../../../../../config/endpoints';
import { POST } from '../../../../../config/permissions';

const ItinerarySendGrrButton = ({
  itineraryId,
  useV2,
  dispatchPostBillingGrrByItinerary,
  dispatchPostBillingGrrByItineraryV2,
}) => {
  const onSendGrr = () => {
    if (useV2) {
      dispatchPostBillingGrrByItineraryV2(itineraryId);
    } else {
      dispatchPostBillingGrrByItinerary(itineraryId);
    }
  };
  return (
    <Button color="light" className="border" onClick={onSendGrr}>
      <i className="fa fa-send" /> Enviar GRR
    </Button>
  );
};

ItinerarySendGrrButton.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  useV2: PropTypes.bool,
  dispatchPostBillingGrrByItinerary: PropTypes.func.isRequired,
  dispatchPostBillingGrrByItineraryV2: PropTypes.func.isRequired,
};

ItinerarySendGrrButton.defaultProps = {
  useV2: false,
};

const mapDispatchToProps = {
  dispatchPostBillingGrrByItinerary: postBillingGrrByItinerary,
  dispatchPostBillingGrrByItineraryV2: postBillingGrrByItineraryV2,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(ItinerarySendGrrButton);

export default withEndpointAuthorization({
  url: generateGrrBillingByItineraryEndpoint(0),
  permissionType: POST,
})(connectedComponent);
